import React from 'react';
import { Table } from 'react-bootstrap';

class QueueList extends React.Component {
    buildBody() {
        return this.props.queueList.map((queue, key) => {
            return (
                <tr key={key}>
                    <td>
                        {queue.name}
                    </td>
                    <td>
                        {queue.amtOfMessages}
                    </td>
                    <td>
                        {queue.amtOfDelayedMessages}
                    </td>
                </tr>
            );
        });
    }

    render() {
        return (
            <Table responsive>
                <thead>
                    <tr>
                        <th>
                            Queue
                  </th>
                        <th>
                            Messages Available
                  </th>
                        <th>
                            Messages in Flight
                  </th>
                    </tr>
                </thead>
                <tbody>
                    {this.buildBody()}
                </tbody>
            </Table>
        );
    }
}

export default QueueList;



// WEBPACK FOOTER //
// ./src/areas/admin/console/queues/QueueList.js